<template>
  <el-dialog :title="$t('platformCoupon.addCoupon')" :visible.sync="dialogVisible" width="70%"
    @close="handleClose">
    <el-form ref="form" :model="addCouponInfo" label-width="120px">
      <el-form-item :label="$t('platformCoupon.couponCode')" :rules="[{ required: true, message: $t('platformCoupon.couponCodeRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.couponCode"
          :placeholder="$t('platformCoupon.couponCodeRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.couponName')" :rules="[{ required: true, message: $t('platformCoupon.couponNameRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.couponName"
          :placeholder="$t('platformCoupon.couponNameRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.couponType')" :rules="[{ required: true, message: $t('platformCoupon.couponTypeRequired'), trigger: 'change' }]">
        <el-select v-model="addCouponInfo.couponType" :placeholder="$t('platformCoupon.couponTypeRequired')"
          style="width:100%" @change="_changeCouponType">
          <el-option disabled :value="''" :label="$t('platformCoupon.couponTypeRequired')" />
          <el-option :label="$t('platformCoupon.fullReduction')" value="01" />
          <el-option :label="$t('platformCoupon.discount')" value="02" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="addCouponInfo.couponType === '01'" :label="$t('platformCoupon.discountAmount')"
        :rules="[{ required: true, message: $t('platformCoupon.discountAmountRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.discountAmount" type="number"
          :placeholder="$t('platformCoupon.discountAmountRequired')" />
      </el-form-item>

      <el-form-item v-if="addCouponInfo.couponType === '02'" :label="$t('platformCoupon.discountPercent')"
        :rules="[{ required: true, message: $t('platformCoupon.discountPercentRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.discountPercent" type="number"
          :placeholder="$t('platformCoupon.discountPercentRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.minAmount')">
        <el-input v-model="addCouponInfo.minAmount" type="number"
          :placeholder="$t('platformCoupon.minAmountPlaceholder')" />
      </el-form-item>

      <el-form-item v-if="addCouponInfo.couponType === '02'" :label="$t('platformCoupon.maxDiscount')">
        <el-input v-model="addCouponInfo.maxDiscount" type="number"
          :placeholder="$t('platformCoupon.maxDiscountPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.description')">
        <el-input v-model="addCouponInfo.description" type="textarea"
          :placeholder="$t('platformCoupon.descriptionPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.totalQuantity')"
        :rules="[{ required: true, message: $t('platformCoupon.totalQuantityRequired'), trigger: 'blur' }]">
        <el-input v-model="addCouponInfo.totalQuantity" type="number"
          :placeholder="$t('platformCoupon.totalQuantityRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.limitPerUser')">
        <el-input v-model="addCouponInfo.limitPerUser" type="number"
          :placeholder="$t('platformCoupon.limitPerUserPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.validDays')">
        <el-input v-model="addCouponInfo.validDays" type="number"
          :placeholder="$t('platformCoupon.validDaysPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.startTime')">
        <el-date-picker v-model="addCouponInfo.startTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('platformCoupon.startTimePlaceholder')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.endTime')">
        <el-date-picker v-model="addCouponInfo.endTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('platformCoupon.endTimePlaceholder')" style="width:100%" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveCouponInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { savePlatformCoupon } from '@/api/coupon/couponApi'

export default {
  name: 'AddPlatformCoupon',
  data() {
    return {
      dialogVisible: false,
      addCouponInfo: {
        couponCode: '',
        couponName: '',
        couponType: '',
        description: '',
        discountAmount: '',
        discountPercent: '',
        minAmount: '0',
        maxDiscount: '',
        totalQuantity: '',
        limitPerUser: '1',
        // 平台券发放方式固定为用户领取
        issueType: '01',
        validDays: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.addCouponInfo = {
        couponCode: '',
        couponName: '',
        couponType: '',
        description: '',
        discountAmount: '',
        discountPercent: '',
        minAmount: '0',
        maxDiscount: '',
        totalQuantity: '',
        limitPerUser: '1',
        // 平台券发放方式固定为用户领取
        issueType: '01',
        validDays: '',
        startTime: '',
        endTime: ''
      }
    },
    _changeCouponType() {
      // 切换优惠类型时清空相关字段
      if (this.addCouponInfo.couponType === '01') {
        this.addCouponInfo.discountPercent = ''
        this.addCouponInfo.maxDiscount = ''
      } else {
        this.addCouponInfo.discountAmount = ''
      }
    },
    async saveCouponInfo() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            await savePlatformCoupon(this.addCouponInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          }
        })
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>
